<div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark py">STUDENT REQUEST COURSES</h4>
        </div>
      </div>
      <div class="p-3">
        <div class="table-responsive" *ngIf="customers.length > 0; else noDataTemplate">
          <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Requested Course</th>
                <th>Name</th>
                <th>Number</th>
                <th>District</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customer of customers">
                <td>{{ customer.requested_course }}</td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.number }}</td>
                <td>{{ customer.district }}</td>
                <td>
                  <button class="btn"
                    [ngClass]="{
                      'btn-warning': customer.status === 'Available For Mentoring',
                      'btn-primary': customer.status === 'Mentor allocate',
                      'btn-success': customer.status === 'completed'
                    }"
                    data-toggle="modal" data-target="#myModal" (click)="Formreset()">
                    {{ customer.status }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noDataTemplate>
          <div class="d-flex justify-content-center">
            <p>No data available.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  
  <div class="modal fade" id="myModal">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="card-header show-header ">
          <h3 class="card-title">COURSE CREATE</h3>
          <button type="button" class="close" data-dismiss="modal" (click)="Formreset()">&times;</button>
        </div>
  
        <div class="card-body">
          <form class="register-form" [formGroup]='mentorcourse' (ngSubmit)="postdata()" autocomplete="off">
            <div class="form-group row">
              <div class="form-group col-md-6">
                <label class="form-label">Course Name</label>
                <span class="required">*</span>
                <input type="text" class="form-control" formControlName="course_name" placeholder="Enter Course Name" />
                <div style="color:red;" *ngIf="mentorcourse.get('course_name').touched && mentorcourse.get('course_name').invalid" class="invalid-msg">Please fill the field</div>
              </div>
              <div class="form-group col-md-6">
                <label>Course Topic</label><span class="required"> *</span>
                <input type="text" class="form-control" formControlName="course_topic" placeholder="Enter Course Topic" />
                <div *ngIf="mentorcourse.get('course_topic').touched && mentorcourse.get('course_topic').invalid" class="invalid-msg">Please fill the field</div>
              </div>
              <div class="row" style="display:none">
                <input type="number" formControlName="user_id" />
              </div>
              <div class="form-group col-md-12">
                <label class="form-label">Course Description</label>
                <textarea type="text" class="form-control" formControlName="course_des" placeholder="Enter Course Description"></textarea>
              </div>
            </div>
  
            <div class="form-group row">
              <div class="col-md-6">
                <label class="form-label">Course Date</label><span class="required">*</span>
                <input type="date" class="form-control" formControlName="course_date" placeholder="Enter Course Date" [min]="getCurrentDates()">
                <div *ngIf="mentorcourse.get('course_date').touched && mentorcourse.get('course_date').invalid" class="invalid-msg">Please fill the field</div>
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Course Time</label><span class="required">*</span>
                <input type="time" class="form-control" formControlName="course_time" placeholder="Enter Course Time">
                <div *ngIf="mentorcourse.get('course_time').touched && mentorcourse.get('course_time').invalid" class="invalid-msg">Please fill the field</div>
              </div>
            </div>
  
            <div class="form-group col-md-12">
              <label class="form-label">
                Online Meeting Link:
                <a href="https://meet.google.com/landing" target="_blank">Google Meet</a>/
                <a href="https://app.zoom.us/wc" target="_blank">Zoom Meet</a>
                <span class="required">*</span>
              </label>
              <input type="text" class="form-control" formControlName="session_link" placeholder="Enter Meet Link" />
              <div *ngIf="mentorcourse.get('session_link').touched && mentorcourse.get('session_link').invalid" class="invalid-msg">Please fill the field</div>
            </div>
            <div class="col-md-12">
              <label>Comments</label>
              <textarea type="text" class="form-control" formControlName="comments" placeholder="Enter your Comments"></textarea>
            </div>
            <div class="form-group mt-3">
              <div class="text-center">
                <button class="btn btn-primary btn-sm font-weight-bold mx-2" type="submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  